<template>
    <div class="production-line-edit-container">
        <div class="container">
            <div class="card">
                <div class="card-header">
                    <div class="row">
                        <div class="card-header-label col-6">
                            <span>Editar línea de producción</span>
                        </div>
                        <div class="card-header-action-buttons col-6">
                            <ButtonComponent
                                :buttonText="'Refrescar'"
                                :buttonColor="colors.BLUE_COLOR_BUTTON"
                                :buttonAction="refreshData"
                            />
                        </div>
                    </div>
                </div>
                <SpeenComponent v-if="isLoading" style="padding: 5ch 0;"
                    :isAutomatic="true"
                    :ringWidth="14"
                    :spinnerSize="15"
                    :isverticalAligned="true"sd
                />
                <div class="card-body" v-else>
                    <form @submit.prevent="updateProductionLine">
                        <div class="row">
                            <div class="col-12 col-sm-6 col-md-2 mb-2">
                                <label for="code" class="form-label">Código</label>
                                <input v-model="formData.code" id="code" class="form-control" required :disabled="!canUpdateProductionLine" />
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 mb-2">
                                <label for="name" class="form-label">Nombre</label>
                                <input v-model="formData.name" id="name" class="form-control" required :disabled="!canUpdateProductionLine" />
                            </div>
                            <div class="col-12 col-sm-12 col-md-4 mb-2">
                                <label for="descrip" class="form-label">Descripción</label>
                                <input v-model="formData.descrip" id="descrip" class="form-control" required :disabled="!canUpdateProductionLine" />
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 mb-2">
                                <label for="packaging_format_id" class="form-label">Formato por defecto</label>
                                <select v-model="formData.packaging_format_id" id="packaging_format_id" class="form-control" required :disabled="!canUpdateProductionLine">
                                    <option disabled value="">Seleccione un formato</option>
                                    <option v-for="format in packagingFormats" :key="format.id" :value="format.id">
                                        {{ format.descrip }}
                                    </option>
                                </select>
                            </div>
                        </div>

                        <div class="row mt-1">
                            <div class="col-12 col-sm-6 col-md-3 mb-2">
                                <label for="operator_count" class="form-label">Nº Operarios MMTO/AUX</label>
                                <input v-model="formData.operator_count" id="operator_count" class="form-control" required :disabled="!canUpdateProductionLine" />
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 mb-2">
                                <label for="salary" class="form-label">Salario bruto anual</label>
                                <input v-model="formData.salary" id="salary" class="form-control" required :disabled="!canUpdateProductionLine" />
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 mb-2">
                                <label for="micro_stops_min_time" class="form-label">Tiempo min. microparada (s)</label>
                                <input v-model="formData.micro_stops_min_time" id="micro_stops_min_time" class="form-control" required :disabled="!canUpdateProductionLine" />
                            </div>
                            <div class="col-12 col-sm-6 col-md-3 mb-2">
                                <label for="micro_stops_max_time" class="form-label">Tiempo max. microparada (s)</label>
                                <input v-model="formData.micro_stops_max_time" id="micro_stops_max_time" class="form-control" step="any" required :disabled="!canUpdateProductionLine" />
                            </div>
                        </div>

                        <div class="row mt-1">
                            <div class="col-12 col-sm-6 col-md-2 mb-2">
                                <label for="target_oee" class="form-label">OEE Objetivo</label>
                                <input v-model="formData.target_oee" id="target_oee" class="form-control" required :disabled="!canUpdateProductionLine" />
                            </div>
                            <div class="col-12 col-sm-6 col-md-5 mb-2">
                                <label for="base-topic-name" class="form-label">Nombre base tópico</label>
                                <input v-model="formData.base_topic_name" id="base-topic-name" class="form-control" :disabled="!canUpdateProductionLine" />
                            </div>
                            <div class="col-12 col-sm-6 col-md-5 mb-2">
                                <label for="datalogger_id" class="form-label">Datalogger</label>
                                <select v-model="formData.datalogger_id" id="datalogger_id" class="form-control" required :disabled="!canUpdateProductionLine">
                                    <option disabled value="">Seleccione un datalogger</option>
                                    <option v-for="datalogger in dataloggersData" :key="datalogger.id" :value="datalogger.id">
                                        {{ datalogger.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <hr>
                        <div class="d-flex justify-content-end">
                            <ButtonComponent
                                v-if="canUpdateProductionLine"
                                :buttonText="'Guardar'"
                                :buttonColor="colors.GREEN_COLOR_BUTTON"
                            />
                        </div>
                    </form>
                    <hr>
                    <div class="production-line-station-header">
                        <div class="row">
                            <div class="production-line-station-header-label col-2">
                                <span>Estaciones</span>
                            </div>
                            <div class="production-line-station-header-pagination col-8">
                                <b-pagination 
                                    v-model="currentPage" 
                                    :total-rows="stationsData.length" 
                                    :per-page="perPage" 
                                    aria-controls="production-line-stations-table" 
                                    style="margin: 0"
                                    align="center" 
                                />
                            </div>
                            <div class="production-line-station-header-action-buttons col-2">
                                <ButtonComponent
                                    :buttonText="'Nueva'"
                                    :buttonColor="colors.GREEN_COLOR_BUTTON"
                                    :buttonAction="openStationCreateModal"
                                />
                            </div>
                        </div>
                    </div>
                    <hr>
                    <template>
                        <b-table
                            id="production-line-stations-table" 
                            striped 
                            hover 
                            :items="stationsData" 
                            :fields="fields" 
                            responsive 
                            :per-page="perPage" 
                            :current-page="currentPage"
                            >
                            <template v-slot:cell(actions)="data">
                                <ButtonComponent
                                    :buttonText="'Editar'"
                                    :buttonColor="colors.GREEN_COLOR_BUTTON"
                                    :buttonAction="() => editStation(data.item)"
                                />
                                <ButtonComponent
                                    :buttonText="'Borrar'"
                                    :buttonColor="colors.RED_COLOR_BUTTON"
                                    :buttonAction="() => confirmDeleteStation(data.item)"
                                />
                            </template>
                        </b-table>
                    </template>
                </div>
            </div>
        </div>
        <transition name="slide-fade">
            <ActionConfirmModal
                v-if="showActionConfirmModal"
                :contentMessage="actionConfirmModalMessage"
                :closeModal="closeActionConfirmModal"
                :methodForProp="methodForProp"
            />
            <StationCreateModal
                v-if="showCreateStationModalData"
                :productionLineId="productionLineId"
                @station-created="refreshData"
                @close-modal="closeCreateStationModal"
            />
        </transition>
    </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import SpeenComponent from '../../common/components/SpeenComponent.vue';
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from '../../common/utils';
import PermissionsConsts from '../../common/permissions';
import ButtonComponent from '../../common/components/ButtonComponent.vue';
import Colors from '../../common/colors';
import ActionConfirmModal from '../../common/components/modals/ActionConfirmModal.vue'; 
import StationCreateModal from '../components/StationCreateModal.vue';

export default {
    name: 'ProductionLineEdit',
    components: {
        SpeenComponent,
        ButtonComponent,
        ActionConfirmModal,
        StationCreateModal
    },
    props: {
        productionLineIdProp: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            formData: {
                code:   '',
                name:  '',
                descrip: '',
                target_oee:  '',
                operator_count: '',
                salary:  '',
                micro_stops_min_time: '',
                micro_stops_max_time: '',
                packaging_format_id:  '',
                datalogger_id:  '',
            },
            showCreateStationModalData: false,
            newStation: {
                code: '',
                descrip: ''
            },
            stationsData: [],
            dataloggersData: [],
            productionLine: null,
            productionLineId: this.productionLineIdProp,
            packagingFormats: [],
            machineTypes: [],
            isLoading: true,
            colors: Colors,
            currentPage: 1,
            perPage: 5,
            showActionConfirmModal: false,
            actionConfirmModalMessage: '',
            methodForProp: null,
            fields: [
                { key: 'code',      label: 'Código', sortable: true},
                { key: 'actions',   label: 'Acciones'},
            ],
        };
    },
    methods: {
        getProductionLineEditVueData(){
            this.isLoading = true;
            axios.get('/api/production-line/form-edit/' + this.productionLineId)
                .then(response => {
                    this.productionLine = response.data.productionLine;
                    this.packagingFormats = response.data.packagingFormats;
                    this.machineTypes = response.data.machineTypes;
                    this.stationsData = response.data.stations;
                    this.dataloggersData = response.data.dataloggers;
                    this.formData = {
                        code: this.productionLine.code,
                        name: this.productionLine.name,
                        descrip: this.productionLine.descrip,
                        target_oee: this.productionLine.target_oee,
                        operator_count: this.productionLine.operator_count,
                        salary: this.productionLine.salary,
                        micro_stops_min_time: this.productionLine.micro_stops_min_time,
                        micro_stops_max_time: this.productionLine.micro_stops_max_time,
                        packaging_format_id: this.productionLine.packaging_format_id,
                        datalogger_id: this.productionLine.datalogger_id,
                        ext_pk: this.productionLine.ext_pk,
                        base_topic_name: this.productionLine.base_topic_name,
                    };
                })
                .catch(error => {
                    console.log(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        refreshData(){
            this.getProductionLineEditVueData();
        },
        editStation(station){
            window.location.href = `/station/${station.id}/edit`;
        },
        getStations() {
            axios.get('/api/production-line/form-edit/' + this.productionLineId + '/stations')
                .then(response => {
                    this.stationsData = response.data;
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        getProductionLine() {
            axios.get('/api/production-line/' + this.productionLineId)
                .then(response => {
                    this.productionLine = response.data;
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                });
        },
        openStationCreateModal() {
            this.showCreateStationModalData = true;
        },
        closeCreateStationModal() {
            this.showCreateStationModalData = false;
        },
        updateProductionLine() {
            axios.patch('/api/production-line/admon/' + this.productionLineId, this.formData)
                .then(() => {
                    showCustomSuccessSweetAlert('Linea de producción actualizada correctamente');
                    this.refreshData();
                })
                .catch(error => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
        },
        confirmDeleteStation(station) {
            this.actionConfirmModalMessage = `¿Está seguro de que desea eliminar la estación ${station.code}?`;
            this.methodForProp = () => {
                this.deleteStation(station.id);
            };
            this.openActionConfirmModal();
        },
        deleteStation(stationId) {
            axios.delete(`/api/station/${stationId}`)
            .then(() => {
                showCustomSuccessSweetAlert('Estación eliminada correctamente');
            })
            .catch(error => {
                console.error(error);
                showCustomErrorSweetAlert(error.response.data);
            })
            .finally(() => {
                this.closeActionConfirmModal();
                this.getStations();
            });
        },
        openActionConfirmModal() {
            this.showActionConfirmModal = true;
        },
        closeActionConfirmModal() {
            this.showActionConfirmModal = false;
        },
    },
    computed: {
        ...mapGetters('production_line', ['productionLineToEditIdValue']),
        ...mapGetters(['userPermissions','userHasPermission', 'isUserSuperadmin']),
        canUpdateProductionLine() {
            return this.isUserSuperadmin;
        },
        canCreateStation() {
            return this.isUserSuperadmin;
        },
        canEditStation() {
            return this.isUserSuperadmin;
        },
        canDeleteStation() {
            return this.isUserSuperadmin;
        },
        visibleStationSection() {
            return this.stationsData.length > 0 || this.canCreateStation;
        }
    },
    mounted() {
        this.getProductionLineEditVueData();
    }
}
</script>

<style lang="scss">
.production-line-edit-container {
    #production-line-stations-table {
        [aria-colindex="1"] { width: 88%; }
        [aria-colindex="2"] { width: 12%; }
    }


    .production-line-station-header{
        .production-line-station-header-label{
            display: flex;
            align-items: center;
        }
        .production-line-station-header-action-buttons{
            display: flex;
            justify-content: flex-end;
        }
    } 
}
</style>
